// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FilePdfTwoToneSvg from "@ant-design/icons-svg/es/asn/FilePdfTwoTone";
import AntdIcon from '../components/AntdIcon';

var FilePdfTwoTone = function FilePdfTwoTone(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: FilePdfTwoToneSvg
  }));
};

FilePdfTwoTone.displayName = 'FilePdfTwoTone';
export default React.forwardRef(FilePdfTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/FilePdfTwoTone.js
// module id = 1129
// module chunks = 0